import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import account from './account/reducer';
import accountTypes from './account-types/reducer';
import actionTile from './action-tiles/reducer';
import addAccount from './add-account/reducer';
import appConfig from './app-config/reducer';
import charts from './charts/reducer';
import contribution from './contribution/reducer';
import educationContainer from './education-container/reducer';
import inputTile from './input-tiles/reducer';
import modal from './modal/reducer';
import plans from './participant-profile/reducer';
import participantProfile from './participant-profile/reducer';
import rixCompensation from './participant-profile/reducer';
import retirementAge from './retirement-age/reducer';
import retirementIncomeGoal from './retirement-income-goal/reducer';
import riScenario from './ri-scenario/reducer';
import socialSecurity from './social-security/reducer';
import salary from './salary/reducer';
import spouse from './spouse/reducer';
import strategyModal from './strategy-modal/reducer'
import yodleeConsent from './yodlee-consent/reducer';
import incomeEvents from './income-events/reducer';
import expenseEvents from './expense-events/reducer';
import events from './event/reducer';
import futureInclude from './future-income-expenses/reducer';

const rootReducer = (history: any): any =>
  combineReducers({
    router: connectRouter(history),
    account,
    accountTypes,
    actionTile,
    addAccount,
    appConfig,
    charts,
    contribution,
    educationContainer,
    events,
    expenseEvents,
    futureInclude,
    incomeEvents,
    modal,
    inputTile,
    plans,
    participantProfile,
    rixCompensation,
    retirementAge,
    retirementIncomeGoal,
    riScenario,
    salary,
    socialSecurity,
    spouse,
    yodleeConsent,
    strategyModal,

  });
export default rootReducer;
